import * as React from 'react';
import styles from './Navbar.module.scss';
import SVG from 'react-inlinesvg';
import { useState } from 'react';

//assets
import logo from '../../assets/logo-black-bg.svg';
import closeIcon from '../../assets/icons/close.svg';
//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
import { LoginConnected } from '../Login/Login';

export const UnloggedUserNavbar: React.FC<any> = ({ actions }) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.padding}></div>
      <div className={styles.unloggedUserNavbar}>
        <div className={styles.navbarLogo}>
          <SVG src={logo} />
        </div>
        <div className={styles.rightSide}>
          <p
            onClick={() => setIsLoginModalOpen(true)}
            className={styles.loginButton}
          >
            {tr(t, 'login_login')}
          </p>
        </div>
      </div>
      {isLoginModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} id={styles.modal}>
            <a //eslint-disable-line
              onClick={() => setIsLoginModalOpen(false)}
              className={styles.close}
            >
              <SVG src={closeIcon} />
            </a>

            <LoginConnected actions={actions} />
          </div>
        </div>
      )}
    </>
  );
};
